/**
 *  PasswordModal script file
**/

import userService from '@/api/userService'

export default {
  name: 'PasswordModal',
  mixins: [],
  components: {},
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      currentPassword: null,
      newPassword: null,
      repeatPassword: null
    }
  },
  computed: {
    passwordValid () {
      return this.newPassword && this.newPassword === this.repeatPassword
    },
    formValid () {
      // return this.currentPassword && this.passwordValid
      return this.passwordValid
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async save () {
      if (!this.formValid) {
        return
      }
      this.loading = true
      try {
        await userService.changePassword({
          id: this.user.id,
          oldPassword: this.currentPassword,
          newPassword: this.newPassword
        })
        this.close()
      } catch (err) {
        // eslint-disable-next-line
        console.error('[password-modal.js] Error changing password', err)
      }
      this.loading = false
    }
  }
}
